import { render, staticRenderFns } from "./DeleteCompetencyConfirm.vue?vue&type=template&id=2240ca27"
import script from "./DeleteCompetencyConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteCompetencyConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports